import { type ReactNode, forwardRef } from 'react'

import Box from '@mui/material/Box'
import Paper, { type PaperProps } from '@mui/material/Paper'
import Typography from '@mui/material/Typography'

type Props = PaperProps & {
    label: string
    action?: ReactNode
}

export default forwardRef<HTMLDivElement, Props>(function SaleSection(
    { children, sx, label, action, ...rest },
    ref
) {
    return (
        <Paper ref={ref} sx={{ py: 2, px: 2.5, ...sx }} {...rest}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography
                    gutterBottom
                    variant="subtitle2"
                    sx={{ fontWeight: 600, fontSize: '0.9rem' }}
                >
                    {label}
                </Typography>
                {action}
            </Box>
            {children}
        </Paper>
    )
})
